import PropTypes from 'prop-types'
import React, { memo } from 'react'
import constants from 'app/constants'
import { useRootContext } from 'app/services/RootProvider/RootProvider'
import useAppData from 'app/services/hooks/useAppData'
import RouteTransition from './routes/RouteTransition'

const Home = React.lazy(() =>
  import(/* webpackChunkName: "route-home" */ 'pages/Home/Home')
)
const Create = React.lazy(() =>
  import(/* webpackChunkName: "route-create" */ 'pages/Editor/Create/Create')
)
const Edit = React.lazy(() =>
  import(/* webpackChunkName: "route-edit" */ 'pages/Editor/Edit/Edit')
)
const Account = React.lazy(() =>
  import(/* webpackChunkName: "route-account" */ 'pages/Account/Account')
)
const Marketplace = React.lazy(() =>
  import(
    /* webpackChunkName: "route-marketplace" */ 'pages/Marketplace/Marketplace'
  )
)
const Articles = React.lazy(() =>
  import(/* webpackChunkName: "route-articles" */ 'pages/Articles/Articles')
)
const Investors = React.lazy(() =>
  import(/* webpackChunkName: "route-investors" */ 'pages/Investors/Investors')
)

/**
 *
 * The `Routes` container component manages the routing for the application.
 *
 * @param {object} props - the component props
 * @returns {ReactElement} the element
 */
function Routes (props) {
  const appData = useAppData()
  const { route } = useRootContext()

  /* eslint-enable */
  return (
    <>
      <RouteTransition
        Component={Home}
        data={appData.routes.HOME}
        isActive={route.type === 'home'}
        route={route}
      />
      {constants.MODE !== 0 && (
        <>
          <RouteTransition
            Component={Create}
            data={appData.routes.CREATE}
            isActive={route.type === 'create'}
            route={route}
          />
          <RouteTransition
            Component={Account}
            data={appData.routes.ACCOUNT}
            isActive={route.type === 'account'}
            route={route}
          />
        </>
      )}
      {constants.CAN_EDIT && (
        <RouteTransition
          Component={Edit}
          data={appData.routes.EDIT}
          isActive={route.type === 'edit'}
          route={route}
        />
      )}
      {constants.IS_MARKETPLACE_ENABLED && (
        <RouteTransition
          Component={Marketplace}
          data={appData.routes.MARKETPLACE}
          isActive={route.type === 'marketplace'}
          route={route}
        />
      )}
      <RouteTransition
        Component={Articles}
        data={appData.routes.ARTICLES}
        isActive={route.type === 'articles'}
        route={route}
      />
      <RouteTransition
        Component={Investors}
        data={appData.routes.INVESTORS}
        isActive={route.type === 'investors'}
        rout={route}
      />
    </>
  )
}

/** @type {object} */
Routes.propTypes = {
  routes: PropTypes.shape()
}

/** @type {object} */
Routes.defaultProps = {
  routes: {}
}

// Memoize
export default memo(Routes)
